/**
 * Skeleton — placeholder animado (shimmer) para estados de carregamento.
 *
 * Design System (padrão Notion): em vez de spinner + "Carregando...", as telas
 * mostram a "silhueta" do conteúdo, deixando a transição mais fluida. Apenas
 * visual — sem lógica/estado. Use `className` para definir tamanho (h-/w-).
 *
 * Ex.: <Skeleton className="h-4 w-40" />  |  <Skeleton className="h-10 w-10 rounded-full" />
 */
interface SkeletonProps {
    className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
    return (
        <div
            aria-hidden="true"
            className={`animate-pulse rounded-md bg-slate-200/80 dark:bg-white/10 ${className}`}
        />
    );
}

export default Skeleton;
